<div class="row">
    <div class="col">
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'logins.formsLoginTitle' | t }}</div>
            <div class="detail-page-card-actions">
                <button
                    class="btn btn-raised"
                    [disabled]="user.formsAuthentications.length === 1"
                    (click)="addMethod(authenticationType.FormsLogin)"
                >
                    <i class="fas fa-plus"></i>
                    <span class="d-none d-lg-inline ms-2">{{ 'logins.addButton' | t }}</span>
                </button>
                <button
                    class="btn btn-raised red"
                    [disabled]="user.formsAuthentications.length === 0"
                    (click)="
                        removeMethod(authenticationType.FormsLogin, user.formsAuthentications[0].ID)
                    "
                >
                    <i class="fas fa-trash"></i>
                    <span class="d-none d-lg-inline ms-2">{{ 'logins.removeButton' | t }}</span>
                </button>
            </div>
            <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                @for (method of user.formsAuthentications; track method) {
                    <div class="form-group">
                        <label>{{ 'logins.usernameLabel' | t }}</label>
                        <div class="input-group">
                            <cerrix-textfield
                                [placeholder]="'logins.usernamePlaceholder' | t"
                                [(ngModel)]="method.username"
                                [limitInput]="true"
                            >
                            </cerrix-textfield>
                            <div class="input-group-append">
                                <button
                                    class="btn btn-outline-secondary"
                                    type="button"
                                    (click)="copyEmail(method)"
                                >
                                    {{ 'logins.useEmailButton' | t }}
                                </button>
                            </div>
                        </div>
                        @if (method.ID < 0) {
                            <small class="text-muted">{{ 'logins.passwordSetLinkInfo' | t }}</small>
                        }
                    </div>
                    <div class="form-group row">
                        <div class="col">
                            <div class="input-group">
                                <cerrix-checkbox
                                    [label]="'logins.disableLoginLabel' | t"
                                    fontsize="0.9em"
                                    [(value)]="method.disabled"
                                >
                                </cerrix-checkbox>
                                @if (method.disabled) {
                                    <small>
                                        {{ 'logins.loginDisabledInfo' | t }}
                                    </small>
                                }
                            </div>
                        </div>
                        @if (method.ID > 0) {
                            <div class="col-4 text-end">
                                <button
                                    class="btn btn-outline-secondary"
                                    type="button"
                                    (click)="resetPasswordRequest(method)"
                                >
                                    <i class="far fa-undo-alt" aria-hidden="true"></i>
                                    <span class="d-none d-lg-inline ms-2">{{ 'logins.resetPasswordButton' | t }}</span>
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="col">
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'logins.adLoginTitle' | t }}</div>
            <div class="detail-page-card-actions">
                <button
                    class="btn btn-raised"
                    [disabled]="user.adAuthentications.length === 1"
                    (click)="addMethod(authenticationType.AdLogin)"
                >
                    <i class="fas fa-plus"></i>
                    <span class="d-none d-lg-inline ms-2">{{ 'logins.addButton' | t }}</span>
                </button>
                <button
                    class="btn btn-raised red"
                    [disabled]="user.adAuthentications.length === 0"
                    (click)="removeMethod(authenticationType.AdLogin, user.adAuthentications[0].ID)"
                >
                    <i class="fas fa-trash"></i>
                    <span class="d-none d-lg-inline ms-2">{{ 'logins.removeButton' | t }}</span>
                </button>
            </div>
            <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                @for (method of user.adAuthentications; track method) {
                    <div class="form-group">
                        <label>{{ 'logins.usernameLabel' | t }}</label>
                        <div class="input-group">
                            <cerrix-textfield
                                cssClass="form-control"
                                [placeholder]="'logins.usernamePlaceholder' | t"
                                [(ngModel)]="method.username"
                                inputTooltip
                            ></cerrix-textfield>
                            <div class="input-group-append">
                                <button
                                    class="btn btn-outline-secondary"
                                    type="button"
                                    (click)="copyEmail(method)"
                                >
                                    {{ 'logins.useEmailButton' | t }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <cerrix-checkbox
                            [label]="'logins.disableLoginLabel' | t"
                            fontsize="0.9em"
                            [(value)]="method.disabled"
                        ></cerrix-checkbox>
                        @if (method.disabled) {
                            <small>{{ 'logins.loginDisabledInfo' | t }}</small>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>
